<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <PatientsToolbarInternal
          v-if="showInternalToolbar"
        />
        <PatientsToolbar v-if="showPatientsGrid" />
        <PatientsGrid v-if="showPatientsGrid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import {onMounted} from "vue";
import PatientsToolbar from "@/components/patients/PatientsToolbar.vue";
import PatientsGrid from "@/components/patients/PatientsGrid.vue";
import PatientsToolbarInternal from "@/components/patients/PatientsToolbarInternal.vue";
import {useOrdersStore} from "@/stores/orders";
import {usePatientsGridVisibility} from "@/composables/usePatientsGridVisibility";

const ordersStore = useOrdersStore();
const {showPatientsGrid, showInternalToolbar} = usePatientsGridVisibility();


onMounted(() => {
  ordersStore.resetOrder();
  ordersStore.clearOrderPatient();
});
</script>
